<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
  data() {
    return {
      loader:null
    };
  },
  methods: {

    hideLoader(){
      this.loader && this.loader.hide();
      this.loader = null;
    },

    login() {
      this.$router.push({ path: '/testlogin' })
    },
    hello() {
      this.$router.push({ path: '/hello' })
    }
  }
}
</script>

<style>
</style>
